import {
	Divider,
	Flex,
	IconButton,
	Menu,
	MenuButton,
	MenuItem,
	MenuList,
	Stack,
	Text
} from '@chakra-ui/react';
import { FiMoreVertical } from 'react-icons/fi';

import { useAuth } from '../../../hooks/auth';
import { ClassifDTO } from '../../../dtos/ClassifDTO';

interface DTCardsParams {
	classifs: ClassifDTO[];
	setModalClassifVisible: (param: boolean) => void;
	setClassifModal: (param: ClassifDTO) => void;
	onOpenAlertDelete: () => void;
};

const DTCards: React.FC<DTCardsParams> = ({
	classifs,
	setModalClassifVisible,
	setClassifModal,
	onOpenAlertDelete
}) => {
	const { permissions } = useAuth();

	return (
		<Flex w="100%" flexDir="column" justify="center" align="center">
			{classifs.map(classif => {
				return (
					<Flex
						key={classif.id_classif}
						w="100%"
						bgGradient="linear(to-r, gray.50, gray.100)"
						borderRadius={8}
						boxShadow="xl"
						p={4}
						pr={0}
						m={["2", "4"]}
					>
						<Flex w="100%">
							<Flex flexDir="column" w="94%">
								{/* NOME */}
								<Flex w="100%" flexDir="column">
									<Text
										color="blue.500"
										textTransform="uppercase"
										fontWeight="600"
										fontSize={[14, 15]}
									>
										{classif.nome === '' ? '--' : classif.nome}
									</Text>
									<Text color="gray.500" fontSize={13}>
										{classif.id_classif}
									</Text>
								</Flex>

								{/* DOCUMENTO */}
								<Flex w="100%" mt={1}>
									<Text color="gray.500" fontSize={[13, 15]} fontWeight={500}>
										Doc.:
									</Text>
									&nbsp;
									<Text color="gray.800" fontWeight="500" fontSize={[13, 15]}>
										{classif.nome}
									</Text>
								</Flex>

								{/* TEL - CIDADE - */}
								<Flex flexDir={["column", "row"]} justify={["flex-start", "space-between"]} mt={1}>
									{/* TEL */}
									<Flex w="100%">
										<Text color="gray.500" fontSize={[13, 15]} fontWeight={500}>
											Tel:
										</Text>
										&nbsp;
										<Text color="gray.800" fontWeight="500" fontSize={[13, 15]}>
											{classif.nome ? classif.nome : "--"}	
										</Text>
									</Flex>

									{/* CIDADE */}
									<Flex w="100%">
										{/* CIDADE */}
										<Flex fontSize={[13, 15]} fontWeight={500} color="gray.600" w="100%">
											<Text color="gray.500" fontSize={[13, 15]} fontWeight={500}>
												Cidade:
											</Text>
											&nbsp;
											<Text color="gray.800" fontWeight="500" fontSize={[13, 15]}>
												{classif.nome ? classif.nome : "--"}
											</Text>
										</Flex>
									</Flex>
								</Flex>
							</Flex>

							{/* MENU */}						
							<Flex flexDir="column" justify="flex-end">
								<Menu>
									{({ isOpen }) => (
										<>
											<MenuButton
												border={0}
												fontSize="1.5626rem"
												as={IconButton}
												isActive={isOpen}
												aria-label="Options"
												icon={<FiMoreVertical />}
												variant="outline"
												_hover={{ bg: 'gray.50' }}
											/>

											<MenuList p={0} boxShadow='xl'>
												<MenuItem
													fontSize={16}
													fontWeight={500}
													py={3}
													_hover={{ bg: 'gray.50' }}
													isDisabled
												>
													Detalhes
												</MenuItem>

												{permissions.alterar && (
													<>
														<Divider />

														<MenuItem
															fontSize={16}
															fontWeight={500}
															py={3}
															_hover={{ bg: 'gray.50' }}
															onClick={() => {
																setClassifModal(classif);
																setModalClassifVisible(true);
															}}
														>
															Editar
														</MenuItem>
													</>
												)}

												{permissions.excluir && (
													<>
														<Divider />

														<MenuItem
															fontSize={16}
															fontWeight={500}
															py={3}
															_hover={{ bg: 'gray.50' }}
															onClick={onOpenAlertDelete}
														>
															Excluir
														</MenuItem>
													</>
												)}
											</MenuList>
										</>
									)}
								</Menu>
							</Flex>
						</Flex>
					</Flex>
				);
			})}
		</Flex>
	);
};

export default DTCards;